import { useState } from 'react';

const faqs = [
  {
    q: '体育App推荐与下载指南网站是做什么的？',
    a: '我们是一个专注于体育App推荐与下载指南的专业平台，汇集了市面上热门的体育直播App、运动记录App、竞猜互动App和体育资讯App。通过功能对比、使用攻略和用户评价，帮助球迷和运动爱好者快速找到最适合自己的体育App。',
  },
  {
    q: '如何选择适合自己的体育直播App？',
    a: '选择体育直播App时，建议从以下几个维度考虑：1）赛事版权——确认你想看的比赛是否在该平台播出；2）画质体验——是否支持高清甚至4K画质；3）解说团队——专业的解说能提升观赛体验；4）价格——根据预算选择免费或付费会员方案。我们也提供了详细的横向对比文章，帮助你做出决策。',
  },
  {
    q: '运动记录App的数据准确吗？',
    a: '主流运动记录App如Keep、咕咚、悦跑圈等，通过GPS定位和传感器数据采集，在跑步距离、配速、卡路里消耗等核心指标上已达到较高精度。但GPS信号受环境影响（如高楼、隧道），数据可能存在小幅偏差。建议配合专业运动手表使用以获得更精准的数据。',
  },
  {
    q: '这些体育App是否免费？',
    a: '大部分推荐的体育App都提供免费基础功能，如Keep的基础课程、直播吧的免费直播源等。但高清画质、独家赛事、专业训练计划等高级功能通常需要付费会员。我们建议先使用免费版体验，确认适合后再考虑升级。',
  },
  {
    q: '如何下载这些体育App？',
    a: '所有推荐的App都可以通过iOS App Store或Android各大应用商店（如华为应用市场、小米应用商店、应用宝等）搜索下载。部分App也提供官方网站直接下载APK安装包。我们建议优先从官方应用商店下载，以确保安全。',
  },
  {
    q: '网站上的推荐是否客观公正？',
    a: '我们的推荐基于多维度的客观评测，包括功能对比、用户评分、下载量、用户体验等。我们与部分平台有合作关系，但这不影响我们的评测标准。每篇文章都注明了评测维度和数据来源，力求为用户提供真实、有价值的参考信息。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于体育App推荐与下载的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-950 text-sm pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}